<template>
  <section class="hero is-fullheight aboutus-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline">

          <div class="column is-12 has-text-centered">
            <h1>Pyrollkaupan Asiakaspalvelu</h1>
            <p>Asiakaspalvelu on avoinna arkisin klo 8.00 – 16.00</p>
            <p>asiakaspalvelu@packagemedia.fi</p>
            <p>puh. 05 747 2200 tai 050 5320575</p>
          </div>

        </div>
      </div>
    </div>
    <PmFooter />
  </section>  
</template>

<script>
import PmNavbar from "../components/PmNavbar";
import PmFooter from "../components/PmFooter";

export default {
  name: "AboutUsPage",
  components: {
    PmNavbar,
    PmFooter,
  },
  data() {
    return {}
  },
  methods: {
    goToContactDataFooter() {
      const element = document.getElementById("contact-data-footer");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if(this.$route.hash && this.$route.hash == '#video-anchor') {
        document.getElementById("video-anchor").scrollIntoView();
      }
    }, 500)
  },
  computed: {},
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.aboutus-page {
  .blue-bg {
    background-color: $pyroll-violet;
  }
  .cstm-icon {
    height: 80px;
    margin-top: 45px;
  }
  .contact-info {
    background-color: $pyroll-violet;
    padding: 50px;
    h3 {
      color: white;
      font-size: 35px;
    }
    p {
      color: white;
      font-size: 16px;
      font-family: Ubuntu;
    }
    a {
      color: white;
    }
  }
}
.mobile-content {
  @media (max-width: 768px) {
    padding: 20px;
  }
}
.quote-icon {
  fill: $pyroll-violet;
}

.light-blue-bg {
  background-color: #4C41841A;
}

.header-about {
  padding: 50px;
  h3 {
    font-size: 35px;
    color: $pyroll-dark-blue;
  }
  p {
    color: $pyroll-dark-blue;
  }
}

.header-about-img {
  width: 100%;
  height: 100%;
  min-height: 400px;
  background-image: url('../assets/img/Intersection1@2x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.contact-bg-img {
  width: 100%;
  height: 100%;
  min-height: 400px;
  background-image: url('../assets/img/Group112@2x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

</style>
